// extracted by mini-css-extract-plugin
module.exports = {"LastMessage":"Message_LastMessage__q5K86"};